module.exports = __webpack_public_path__ + "media/promo/advent/images/logo-3-20816b1a537fd2779601d94f9c8ce7bd.png";